// extracted by mini-css-extract-plugin
export default {"form":"menu_form__wnf+z","sucursales":"menu_sucursales__I69Dz","check":"menu_check__dq4CD"};